import { useOwnerCurrency } from "@/hooks/useOwnerCurrency";
import { useRevenueData } from "@/hooks/budget/useRevenueData";
import { RevenueStatsSection } from "../sections/RevenueStatsSection";
import { RevenueChartsSection } from "../sections/RevenueChartsSection";

export const RevenuesTab = () => {
  const { data: currency } = useOwnerCurrency();
  const { currentMonthData, previousMonthData, validatedAmount } = useRevenueData();

  const currentTotal = validatedAmount || 0;
  const previousTotal = previousMonthData?.totalRevenue || 0;
  const growthRate = previousTotal ? ((currentTotal - previousTotal) / previousTotal) * 100 : 0;

  return (
    <div className="space-y-6">
      <RevenueStatsSection
        validatedAmount={validatedAmount || 0}
        averageDaily={currentMonthData?.averageDaily || 0}
        transactionCount={currentMonthData?.transactionCount || 0}
        growthRate={growthRate}
        currency={currency || ""}
      />

      <RevenueChartsSection
        currentData={currentMonthData?.data || []}
        previousData={previousMonthData?.data || []}
      />
    </div>
  );
};